var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99992 9.33337C2.36811 9.33337 2.66659 9.63185 2.66659 10V12.6667C2.66659 12.8435 2.73682 13.0131 2.86185 13.1381C2.98687 13.2631 3.15644 13.3334 3.33325 13.3334H12.6666C12.8434 13.3334 13.013 13.2631 13.138 13.1381C13.263 13.0131 13.3333 12.8435 13.3333 12.6667V10C13.3333 9.63185 13.6317 9.33337 13.9999 9.33337C14.3681 9.33337 14.6666 9.63185 14.6666 10V12.6667C14.6666 13.1971 14.4559 13.7058 14.0808 14.0809C13.7057 14.456 13.197 14.6667 12.6666 14.6667H3.33325C2.80282 14.6667 2.29411 14.456 1.91904 14.0809C1.54397 13.7058 1.33325 13.1971 1.33325 12.6667V10C1.33325 9.63185 1.63173 9.33337 1.99992 9.33337Z",
    fill: "#A793F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19526 6.19526C4.45561 5.93491 4.87772 5.93491 5.13807 6.19526L8 9.05719L10.8619 6.19526C11.1223 5.93491 11.5444 5.93491 11.8047 6.19526C12.0651 6.45561 12.0651 6.87772 11.8047 7.13807L8.4714 10.4714C8.21106 10.7318 7.78894 10.7318 7.5286 10.4714L4.19526 7.13807C3.93491 6.87772 3.93491 6.45561 4.19526 6.19526Z",
    fill: "#A793F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 1.33337C8.36811 1.33337 8.66659 1.63185 8.66659 2.00004V10C8.66659 10.3682 8.36811 10.6667 7.99992 10.6667C7.63173 10.6667 7.33325 10.3682 7.33325 10V2.00004C7.33325 1.63185 7.63173 1.33337 7.99992 1.33337Z",
    fill: "#A793F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.cf1fd6b7799fc93c28e81937c9a16a1f.svg";
export { ForwardRef as ReactComponent };